import React, { memo, useEffect, useMemo, useState } from 'react';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import ReactMarkdown from 'react-markdown';
import { Button, Divider, Image, Input, message, Steps, Tooltip } from 'antd';
import scss from './AiIssueAnalysisQueryRenderer.scss';

const markdownComponents = {
  img({ node, ...props}) {
    return <div style={{ maxWidth:'100%' }}>
      <Image src={props.src} />
    </div>
  },
  th: ({ node, ...props }) => (
    <th style={{ border: '1px solid #aaa', padding: '8px', textAlign: 'left' }} {...props}>
      {props.children}
    </th>
  ),
  td: ({ node, ...props }) => (
    <td style={{ border: '1px solid #aaa', padding: '8px' }} {...props}>
      {props.children}
    </td>
  ),
  code: ({ node, inline, ...props }) => {
    if (inline) {
      // 行内代码样式
      return (
        <code
          style={{
            backgroundColor: '#2d3748',
            color: '#e2e8f0',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '0.875em',
            fontFamily: 'Consolas, Monaco, "Courier New", monospace'
          }}
          {...props}
        >
          {props.children}
        </code>
      );
    } else {
      // 代码块样式 - 不设置高度限制和滚动，由pre元素控制
      return (
        <code
          style={{
            backgroundColor: 'transparent',
            color: '#e2e8f0',
            fontSize: '0.875em',
            fontFamily: 'Consolas, Monaco, "Courier New", monospace',
            whiteSpace: 'pre-wrap', // 支持自动换行
            wordBreak: 'break-word' // 长单词自动换行
          }}
          {...props}
        >
          {props.children}
        </code>
      );
    }
  },
  pre: ({ node, ...props }) => (
    <pre
      style={{
        backgroundColor: '#2d3748',
        borderRadius: '8px',
        margin: '16px 0',
        padding: '16px',
        overflow: 'auto',
        maxHeight: '320px',
        whiteSpace: 'pre-wrap', // 支持自动换行
        wordBreak: 'break-word' // 长单词自动换行
      }}
      onScroll={(e) => {
        // 阻止滚动事件冒泡到父级容器，避免触发AiDrawerAutoScrollBody的自动滚动
        e.stopPropagation();
      }}
      {...props}
    >
      {props.children}
    </pre>
  ),
};

// 配置rehype-sanitize的安全白名单
const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), 'quoted-log-btn'],
  attributes: {
    ...defaultSchema.attributes,
    '*': [...(defaultSchema.attributes['*'] || []), 'className', 'style']
  },
};

const AiIssueAnalysisQueryRenderer = ({
  text,
}) => {
  return <div className={scss.aiIssueAnalysisQueryRenderer}>
    <div className={scss.md}>
      <ReactMarkdown
        remarkPlugins={[gfm]}
        linkTarget='_blank'
        children={text}
        components={markdownComponents}
      />
    </div>
  </div>;
};

export default AiIssueAnalysisQueryRenderer;
